<template>
  <div class="gvl-impressum">
    <div class="field-item even" property="content:encoded">
      <p>GESELLSCHAFT ZUR VERWERTUNG VON LEISTUNGSSCHUTZRECHTEN mbH (GVL)</p>
      <p>Podbielskiallee 64</p>
      <p>14195 Berlin</p>
      <p>Postfach 330361</p>
      <p>14173 Berlin</p>
      <p>Telefon: 0202-2515 57305</p>
      <p>E-Mail: <a href="mailto:kontakt@gvl-stipendienprogramm.de" rel="nofollow">kontakt@gvl-stipendienprogramm.de</a> (Anfragen zum Stipendienprogramm bitte an die Hotline richten.)</p>
      <p>Internet: <a href="https://www.gvl.de" rel="nofollow">https://www.gvl.de</a></p>
      <p>Geschäftsführer der GVL: Dr. Tilo Gerlach und Guido Evers</p>
      <p>Aufsichtsbehörde: Deutsches Patent- und Markenamt, Zweibrückenstr. 12, 80331 München</p>
      <p>Bundeskartellamt, Kaiser-Friedrich-Strasse 16, 53113 Bonn</p>
      <p>Handelsregisternummer: Amtsgericht Charlottenburg, HRB 92075</p>
      <p>USt-IdNr.: DE 118 554 621</p>
      <p>&nbsp;</p>
      <p>Verantwortliche i.S.d. § 55 Abs. 2 RStV: Juliane Fiedler, Podbielskiallee 64, 14195 Berlin</p>
      <p>Haftungsausschluss: Die Inhalte der Webseite gvl.de werden regelmäßig gepflegt und aktualisiert. Jedoch wird keine Gewähr für die Richtigkeit, die Vollständigkeit oder die Verfügbarkeit der im Rahmen des Dienstes abrufbaren Informationen übernommen. Für externe Inhalte, auf die in der Webseite gvl.de hingewiesen wird, wird keine Verantwortung übernommen. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
      <p>Konzeption und Webentwicklung:</p>
      <p><a href="https://nakami.de" target="_blank">nakami lounge GmbH</a>, München</p>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

@Component({
})
export default class Impressum extends Vue {

}
</script>
